import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-600">
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-slate-800 rounded-3xl shadow-xl border border-slate-700 p-8">
          <h1 className="text-3xl font-bold text-white mb-2 text-center">
            Условия использования
          </h1>
          <h2 className="text-xl text-slate-300 mb-6 text-center">
            Условия использования платформы «Сделка и Точка»
          </h2>
          <div className="text-slate-400 text-sm mb-8 text-center">
            (публичная оферта на использование платформы)
          </div>
          <div className="text-slate-300 text-sm mb-8 text-center">
            Дата размещения: 14 августа 2025
          </div>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <p>
              <span className="text-[#7538d5] font-semibold">ООО "ИКС ДРАЙВ"</span>, ИНН: 7842222864, КПП: 784201001, ОГРН: 1247800055436, именуемое в дальнейшем "Оператор платформы", предлагает любому физическому лицу, принявшему условия настоящей оферты, заключить договор на условиях, изложенных ниже.
            </p>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">1. Общие положения</h2>
                <div className="space-y-3">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">1.1.</h3>
                    <p>Настоящие Условия определяют правила использования платформы "Сделка и Точка" (dealtochka.com), включая порядок проведения безопасных сделок с использованием платформы.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">1.2.</h3>
                    <p>Покупателем и продавцом может быть только физическое лицо.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">1.3.</h3>
                    <p>Платформа поддерживает реализацию как цифровых товаров (файлы, изображения, документы, видео и пр.), так и физических товаров, в том числе с доставкой.</p>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">2. Механизм сделки</h2>
                <div className="space-y-3">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">2.1.</h3>
                    <p>Покупатель вносит оплату за товар или услугу на платформе "Сделка и Точка". Средства принимаются платёжным партнёром в безналичной форме.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">2.2.</h3>
                    <p>При продаже товара или услуги доступ к нему предоставляется сразу после успешной оплаты, а денежные средства могут быть немедленно выплачены Продавцу.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">2.3.</h3>
                    <p>При продаже физического товара Продавец вправе установить срок ожидания подтверждения со стороны Покупателя — до 60 календарных дней с момента оплаты. По истечении этого срока, если спор не возник, средства выплачиваются автоматически.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">2.4.</h3>
                    <p>Платформа фиксирует все этапы сделки: оплату, передачу товара, подтверждение и статус выплаты.</p>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">3. Ответственность сторон</h2>
                <div className="space-y-3">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">3.1.</h3>
                    <p>Продавец обязан предоставить достоверную информацию о товаре или услуге, а также соблюдать требования законодательства РФ, включая Закон "О защите прав потребителей".</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">3.2.</h3>
                    <p>Покупатель несёт ответственность за корректность введённых данных при совершении покупки.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">3.3.</h3>
                    <p>Оператор платформы обеспечивает техническое функционирование платформы и техническое сопровождение обработки платежей до наступления оснований для их перечисления.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">3.4.</h3>
                    <p>В случае нарушений условий сделки Оператор вправе инициировать арбитражную проверку.</p>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">4. Правила арбитража</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">Каналы для обращения:</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Форма обратной связи на сайте dealtochka.com</li>
                      <li>Электронная почта: <span className="text-[#7538d5] font-semibold">dispute@dealtochka.com</span></li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">Процедура разрешения споров:</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Заявка на возврат или арбитраж подаётся через указанные каналы.</li>
                      <li>Оператор рассматривает заявку в течение 3 рабочих дней.</li>
                      <li>В спорных случаях создаётся арбитражная комиссия с участием ООО "ИКС ДРАЙВ", которая выносит обязательное для сторон решение.</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">Политика возвратов и чарджбеков:</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Все возвраты проходят через банковскую систему.</li>
                      <li>Чарджбеки рассматриваются как заявки на возврат и требуют дополнительной проверки.</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">Ответственность Продавца:</h3>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>В случае выявления нарушений по претензии покупателя, платформа может удержать средства с баланса Продавца или потребовать компенсацию.</li>
                      <li>Срок подачи претензий со стороны покупателей не ограничен.</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">5. Выплата средств</h2>
                <div className="space-y-3">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">5.1.</h3>
                    <p>Выплата средств Продавцу осуществляется в момент наступления условий сделки: автоматическое подтверждение получения товара/услуги или подтверждение доставки товара.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">5.2.</h3>
                    <p>В случае возврата, средства возвращаются Покупателю в полном объёме.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">5.3.</h3>
                    <p>Выплаты производятся в безналичной форме на банковскую карту, указанную Продавцом.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">5.4.</h3>
                    <p>Сервис «Сделка и Точка» удерживает комиссию в размере 5 % (пять процентов) от суммы каждого успешно завершённого платежа в пользу Продавца. Указанная комиссия автоматически вычитается из суммы, подлежащей выплате Продавцу, и включает все расходы, связанные с эквайрингом, обработкой платежей, идентификацией и сопутствующими операциями.</p>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">6. Ограничение ответственности</h2>
                <p className="mb-3">ООО "ИКС ДРАЙВ" не несёт ответственности за:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Качество товаров или услуг, размещённых Продавцами на платформе.</li>
                  <li>Последствия некорректного или неполного указания данных Покупателем или Продавцом.</li>
                  <li>Форс-мажорные обстоятельства, влияющие на работу платформы или выполнение обязательств сторон.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">7. Прочие условия</h2>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Все транзакции осуществляются через платёжную систему банка, интегрированную в платформу "Сделка и Точка".</li>
                  <li>Услуга доступна только на территории Российской Федерации.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">8. Контактная информация</h2>
                <div className="bg-slate-700 rounded-lg p-6 border border-slate-600">
                  <div className="text-white font-semibold text-lg mb-4">ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ИКС ДРАЙВ"</div>
                  
                  <div className="space-y-2 text-sm">
                    <div><span className="text-slate-400">Юридический адрес:</span> 191036, РОССИЯ, Г.САНКТ-ПЕТЕРБУРГ, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ ЛИГОВКА-ЯМСКАЯ, УЛ ПОЛТАВСКАЯ, Д. 5/29, ЛИТЕРА Д, КВ. 62</div>
                    <div><span className="text-slate-400">ИНН:</span> 7842222864</div>
                    <div><span className="text-slate-400">КПП:</span> 784201001</div>
                    <div><span className="text-slate-400">ОГРН/ОГРНИП:</span> 1247800055436</div>
                    <div><span className="text-slate-400">Расчетный счет:</span> 40702810410001621456</div>
                    <div><span className="text-slate-400">Банк:</span> АО «ТБанк»</div>
                    <div><span className="text-slate-400">ИНН банка:</span> 7710140679</div>
                    <div><span className="text-slate-400">БИК банка:</span> 044525974</div>
                    <div><span className="text-slate-400">Корреспондентский счет банка:</span> 30101810145250000974</div>
                    <div><span className="text-slate-400">Основная сфера деятельности:</span> разработка аппаратно-программных комплексов и систем, консультации в области разработки программных продуктов.</div>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">Перечень товаров и услуг, запрещенных к продаже</h2>
                <div className="bg-red-900/20 rounded-lg p-4 border border-red-700/30">
                  <ul className="list-disc list-inside space-y-1 text-sm">
                    <li>Вооружение, боеприпасы к нему, военная техника, запасные части, комплектующие изделия и приборы к ним, взрывчатые вещества, средства взрывания, все виды ракетного топлива, а также специальные материалы и специальное оборудование для их производства, специальное снаряжение военизированных организаций и нормативно-техническая продукция на их производство и эксплуатацию.</li>
                    <li>Ракетно-космические комплексы, системы связи и управления военного назначения и нормативно-техническая документация на их производство и эксплуатацию.</li>
                    <li>Боевые отравляющие вещества, средства защиты от них и нормативно-техническая документация на их производство и использование.</li>
                    <li>Результаты научно-исследовательских и проектных работ, а также фундаментальных поисковых исследований по созданию вооружения и военной техники.</li>
                    <li>Услуги, работы и материалы, связанные с осуществлением военной службы и военизированной деятельности.</li>
                    <li>Любое оружие, в том числе охотничье, гражданское и иное, а также комплектующие изделия к нему, ножи (за исключением кухонных, перочинных, канцелярских), боеприпасы.</li>
                    <li>Радиоактивные вещества и изотопы, уран и другие делящиеся материалы и изделия из них.</li>
                    <li>Отходы радиоактивных материалов.</li>
                    <li>Драгоценные и редкоземельные металлы, драгоценные камни, а также отходы, содержащие драгоценные и редкоземельные металлы и драгоценные камни.</li>
                    <li>Рентгеновское оборудование, приборы и оборудование с использованием радиоактивных веществ и изотопов.</li>
                    <li>Яды, наркотические средства и психотропные вещества, их прекурсоры.</li>
                    <li>Спирт этиловый, алкогольные напитки.</li>
                    <li>Лекарственные препараты, отпускаемые по рецепту.</li>
                    <li>Лекарственное сырье, получаемое от северного оленеводства.</li>
                    <li>Табачная продукция, никотин-содержащая продукция.</li>
                    <li>Шифровальная техника.</li>
                    <li>Поддельные денежные знаки.</li>
                    <li>Иностранная валюта и валютные ценности.</li>
                    <li>Радиоэлектронные и специальные технические средства для негласного получения информации.</li>
                    <li>Материалы, нарушающие тайну частной жизни.</li>
                    <li>Государственные награды.</li>
                    <li>Государственные удостоверения личности и документы.</li>
                    <li>Объекты культурного наследия.</li>
                    <li>Человеческие органы и ткани.</li>
                    <li>Редкие животные и растения.</li>
                    <li>Рыболовные сети и электроудочки.</li>
                    <li>Экстремистские материалы.</li>
                    <li>Предметы с нацистской символикой.</li>
                    <li>Контрафактная продукция.</li>
                    <li>Базы данных с персональными данными.</li>
                    <li>Виртуальные материалы без носителя.</li>
                    <li>Игровое оборудование для азартных игр.</li>
                    <li>Документы на транспортные средства.</li>
                    <li>Товары, нарушающие интеллектуальные права.</li>
                    <li>Инвестиционные услуги и криптовалюты.</li>
                    <li>Товары сетевого маркетинга.</li>
                    <li>Услуги интимного характера.</li>
                    <li>Несуществующие товары.</li>
                    <li>Услуги нетрадиционной медицины.</li>
                    <li>Услуги по взлому ПО.</li>
                    <li>Инъекционные препараты.</li>
                    <li>Услуги оккультных организаций.</li>
                    <li>Финансовые пирамиды.</li>
                    <li>Антиквариат.</li>
                    <li>БАДы.</li>
                    <li>Услуги онлайн-казино.</li>
                    <li>Букмекерские услуги без лицензии.</li>
                    <li>Брокерские услуги без лицензии.</li>
                    <li>Цифровые финансовые активы.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-6 border-t border-slate-700 text-center">
            <div className="text-slate-400 text-sm">
              ООО "ИКС ДРАЙВ" • ИНН: 7842222864 • КПП: 784201001 • ОГРН: 1247800055436
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
